export default () => ({
  activeModules: [],
})
